import React from 'react'
import img1 from '../allimage/Shopping_Cart.gif'
import logo from '../allimage/logo.png'
import ad1 from '../allimage/i-3.png'
import ad2 from '../allimage/i-11.png'
import ad3 from '../allimage/i-13.png'
import ad4 from '../allimage/i-14.png'
import sl1 from '../allimage/hero-1.jpg'
import sl2 from '../allimage/hero-2.jpg'
import svg1 from '../allimage/1.svg'
import svg2 from '../allimage/2.svg'
import svg3 from '../allimage/3.svg'
import svg4 from '../allimage/4.svg'

const img=[img1,logo,ad1,ad2,ad3,ad4,sl1,sl2,svg1,svg2,svg3,svg4]

export default img